module.exports = __webpack_public_path__ + "img/thumbnail_CoquerelsSifaka_f_normal.600e7c42.png";